import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Content from "../common/Content";
import ContentCenter from "../ui/ContentCenter";
import DifficultySelector from "../ui/DifficultySelector";
import GameArea from "../ui/GameArea";
import PlayButton from "../ui/PlayButton";
import OnPositionLevel from "./OnPosition/OnPositionLevel";




export default ({ onSetLevel, game }: any) => {
  const { t } = useTranslation("games");
  const [level, setLevel] = useState(1);
  const [started, setStarted] = useState(false);
  const [restart, setRestart] = useState(0);

  useEffect(() => {
    setStarted(false);
  }, [level]);

  return (
    <>
      <GameArea style={{ height: "100%" }} game={game}>
        {!started ? (
          <ContentCenter>
            {level === 1 ? (
              <img src={"/catch/img/start-easy.png"} />
            ) : (
              <img src={"/catch/img/start.png"} />
            )}
          </ContentCenter>
        ) : (
          <iframe
            width={500}
            height={370}
            frameBorder="0"
            src={`/catch/index.html?level=${level}&r=${restart}`}
          />
        )}
      </GameArea>

      <Content>
        <div>
          {!started ? (
            <PlayButton
              onClick={() => {
                setStarted(true);
              }}
            ></PlayButton>
          ) : (
            <PlayButton onClick={() => setRestart(restart + 1)}>
              Neu starten
            </PlayButton>
          )}
        </div>
        <DifficultySelector
          switchDifficulty={(level) => {
            onSetLevel(level);
            setLevel(level);
          }}
          levels={3}
          current={level}
        />
      </Content>
    </>
  );
};
